import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      lang_toggle: "עברית",
      bsd: "\u05D1\u05E1\"\u05D3",
      hero_subtitle: "Ont l'honneur de vous convier à leur mariage",
      groom: "Netanael",
      bride: "Agathe",
      and: "&",
      wedding_date: "Mercredi 7 Octobre 2026",
      wedding_date_hebrew: "\u05DB\u05F4\u05D5 \u05EA\u05E9\u05E8\u05D9 \u05EA\u05E9\u05E4\u05F4\u05D6",
      memorial_phrase: "En ce jour chargé de mémoire, nous avons choisi de célébrer la vie, l'amour et l'espoir, entourés de ceux qui comptent le plus pour nous.",
      save_the_date: "Save the date",
      countdown_label: "Avant le grand jour",
      proposal_title: "Notre Histoire",
      proposal_subtitle: "Le jour où tout a commencé",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes",
      rsvp_title: "Confirmez votre présence",
      rsvp_subtitle: "Nous serions honorés de votre présence",
      rsvp_deadline: "RSVP avant le 7 juillet 2026",
      first_name: "Prénom",
      last_name: "Nom",
      email: "Numéro de téléphone",
      attending: "Soirée du mariage",
      attending_shabbat: "Shabbat Hatane",
      will_attend: "Sera présent(e)",
      will_not_attend: "Ne sera pas présent(e)",
      guest_count: "Nombre de personnes",
      message: "Message pour les mariés",
      message_placeholder: "Un petit mot pour Netanael & Agathe...",
      submit: "Envoyer",
      submitting: "Envoi en cours...",
      success_title: "Merci !",
      success_attending: "Votre présence a bien été enregistrée.",
      success_not_attending: "Votre réponse a été enregistrée. Merci de nous avoir répondu.",
      error_already: "Ce numéro a déjà été utilisé pour répondre.",
      error_generic: "Une erreur est survenue. Veuillez réessayer.",
      with_love: "Avec tout notre amour",
      footer_text: "Netanael & Agathe",
      required: "Ce champ est requis",
      invalid_email: "Numéro invalide",
      program_title: "Programme",
      schedule_1: "Apéritif",
      schedule_2: "Houpa",
      schedule_3: "Photos",
      schedule_4: "Entrée des mariés",
      schedule_5: "Rendez-vous sur la piste",
      schedule_6: "Repas",
      schedule_7: "Pièce montée",
      venue_title: "Lieu de réception",
      venue_name: "Levona",
      venue_address: "Arava Desert, Israël",
      venue_directions: "Itinéraire Waze",
      venue_subtitle: "Tout ce que vous devez savoir sur notre journée spéciale",
      venue_location_label: "Lieu",
      venue_date_label: "Mercredi 7 Octobre 2026",
      arrival_time: "Les festivités débuteront à 16h30",
      venue_add_calendar: "Ajouter au calendrier",
      accommodation_title: "Hébergement",
      accommodation_subtitle: "Quelques suggestions pour prolonger la magie du désert",
      accommodation_1_name: "Nof Zuqim",
      accommodation_1_desc: "15 cabanes en pierre avec spa et piscine, à Tzukim même.",
      accommodation_1_distance: "~1 km - 2 min",
      accommodation_1_book: "Réserver",
      accommodation_2_name: "Arava Land",
      accommodation_2_desc: "Lodge avec piscine, jacuzzi et terrasse face au désert. Adultes uniquement.",
      accommodation_2_distance: "~1 km - 2 min",
      accommodation_2_book: "Réserver",
      accommodation_3_name: "Zman Arava",
      accommodation_3_desc: "Suites avec spa, massages et yoga. Ambiance zen au cœur du désert.",
      accommodation_3_distance: "~1 km - 2 min",
      accommodation_3_book: "Réserver",
      accommodation_4_name: "Eilat",
      accommodation_4_desc: "Pour les plus courageux qui veulent en profiter pour voir la mer Rouge !",
      accommodation_4_distance: "~100 km - 1h",
      shuttle_title: "Navette",
      shuttle_text: "Un service de navette sera mis à disposition au départ de Bat Yam pour accompagner les invités à l'aller et au retour le lendemain.",
      shabbat_title: "Shabbat Hatane",
      shabbat_friday: "Vendredi 9 Octobre 2026",
      shabbat_friday_hebrew: "\u05DB\u05F4\u05D7 \u05EA\u05E9\u05E8\u05D9 \u05EA\u05E9\u05E4\u05F4\u05D6",
      shabbat_saturday: "Samedi 10 Octobre 2026",
      shabbat_saturday_hebrew: "\u05DB\u05F4\u05D8 \u05EA\u05E9\u05E8\u05D9 \u05EA\u05E9\u05E4\u05F4\u05D6",
      shabbat_address: "14 Ha Komemiyut, Bat Yam",
      memorial_family: "En mémoire d'Elazar Aimé Chetrit, Zoar Georgette Chetrit et de Jean-Jacques Encausse",
      guest_label: "Accompagnant",
      guest_last_name: "Nom",
      guest_first_name: "Prénom"
    }
  },
  he: {
    translation: {
      lang_toggle: "Français",
      bsd: "בס\"ד",
      hero_subtitle: "שמחים להזמינכם לחתונתם",
      groom: "נתנאל",
      bride: "אגת",
      and: "&",
      wedding_date: "יום רביעי, 7 באוקטובר 2026",
      wedding_date_hebrew: "כ״ו תשרי תשפ״ז",
      memorial_phrase: "ביום הזה, הנושא עמו זיכרון כבד, בחרנו לחגוג את החיים, את האהבה ואת התקווה, מוקפים באלו היקרים לנו ביותר.",
      save_the_date: "שמרו את התאריך",
      countdown_label: "עד היום הגדול",
      proposal_title: "הסיפור שלנו",
      proposal_subtitle: "היום שבו הכל התחיל",
      days: "ימים",
      hours: "שעות",
      minutes: "דקות",
      seconds: "שניות",
      rsvp_title: "אישור הגעה",
      rsvp_subtitle: "נשמח לחגוג יחד איתכם",
      rsvp_deadline: "נא לאשר הגעה עד ה-7 ביולי 2026",
      first_name: "שם פרטי",
      last_name: "שם משפחה",
      email: "מספר טלפון",
      attending: "ערב החתונה",
      attending_shabbat: "שבת חתן",
      will_attend: "אגיע",
      will_not_attend: "לא אגיע",
      guest_count: "מספר אורחים",
      message: "מילים לחתן ולכלה",
      message_placeholder: "כמה מילים לנתנאל ואגת...",
      submit: "שלח",
      submitting: "שולח...",
      success_title: "!תודה רבה",
      success_attending: "ההגעה שלך אושרה בהצלחה.",
      success_not_attending: "התשובה שלך נרשמה. תודה שהגבת.",
      error_already: "המספר הזה כבר שימש לתשובה.",
      error_generic: "אירעה שגיאה. אנא נסה שוב.",
      with_love: "באהבה",
      footer_text: "נתנאל ואגת",
      required: "שדה חובה",
      invalid_email: "מספר לא תקין",
      program_title: "סדר האירוע",
      schedule_1: "קבלת פנים",
      schedule_2: "חופה",
      schedule_3: "צילומים",
      schedule_4: "כניסת החתן והכלה",
      schedule_5: "מסיבה על הרחבה",
      schedule_6: "ארוחה",
      schedule_7: "עוגת חתונה",
      venue_title: "מקום האירוע",
      venue_name: "Levona",
      venue_address: "מדבר הערבה, ישראל",
      venue_directions: "נווט עם Waze",
      venue_subtitle: "כל מה שצריך לדעת על היום המיוחד שלנו",
      venue_location_label: "מיקום",
      venue_date_label: "יום רביעי, 7 באוקטובר 2026",
      arrival_time: "החגיגות יתחילו בשעה 16:30",
      venue_add_calendar: "הוסף ליומן",
      accommodation_title: "לינה",
      accommodation_subtitle: "כמה המלצות כדי להאריך את הקסם של המדבר",
      accommodation_1_name: "Nof Zuqim",
      accommodation_1_desc: "15 בקתות אבן עם ספא ובריכה, בצוקים עצמם.",
      accommodation_1_distance: "~1 ק״מ - 2 דק׳",
      accommodation_1_book: "להזמנה",
      accommodation_2_name: "Arava Land",
      accommodation_2_desc: "לודג׳ עם בריכה, ג׳קוזי ומרפסת מול המדבר. למבוגרים בלבד.",
      accommodation_2_distance: "~1 ק״מ - 2 דק׳",
      accommodation_2_book: "להזמנה",
      accommodation_3_name: "Zman Arava",
      accommodation_3_desc: "סוויטות עם ספא, עיסויים ויוגה. אווירה רגועה בלב המדבר.",
      accommodation_3_distance: "~1 ק״מ - 2 דק׳",
      accommodation_3_book: "להזמנה",
      accommodation_4_name: "אילת",
      accommodation_4_desc: "לאמיצים שרוצים לנצל ולראות את ים סוף!",
      accommodation_4_distance: "~100 ק״מ - שעה",
      shuttle_title: "הסעות",
      shuttle_text: "שירות הסעות יעמוד לרשות האורחים מבת ים, הלוך בערב האירוע וחזור למחרת.",
      shabbat_title: "שבת חתן",
      shabbat_friday: "יום שישי, 9 באוקטובר 2026",
      shabbat_friday_hebrew: "כ״ח תשרי תשפ״ז",
      shabbat_saturday: "יום שבת, 10 באוקטובר 2026",
      shabbat_saturday_hebrew: "כ״ט תשרי תשפ״ז",
      shabbat_address: "הקוממיות 14, בת ים",
      memorial_family: "לזכרם של אלעזר אמה שטרית, זוהר ז'ורז'ט שטרית וז'אן-ז'אק אנקוס",
      guest_label: "מלווה",
      guest_last_name: "שם משפחה",
      guest_first_name: "שם פרטי"
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false }
});

export default i18n;
